import { render, staticRenderFns } from "./WindingSection.vue?vue&type=template&id=7c13510a&scoped=true&"
import script from "./WindingSection.vue?vue&type=script&lang=js&"
export * from "./WindingSection.vue?vue&type=script&lang=js&"
import style0 from "./WindingSection.vue?vue&type=style&index=0&id=7c13510a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c13510a",
  null
  
)

export default component.exports